import { Link } from 'react-router-dom';

export default function FinalCTA() {
  return (
    <section className="py-16 md:py-20" style={{ backgroundColor: '#5B2D1F' }} data-testid="landing-final-cta">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <h2 className="text-3xl sm:text-4xl font-extrabold mb-6" style={{ color: '#FBF6EF' }}>
          Ready to make your medications clearer?
        </h2>
        <Link
          to="/signup"
          data-testid="landing-final-cta-signup-btn"
          className="inline-flex items-center justify-center px-10 py-4 rounded-xl text-lg font-extrabold text-white transition-opacity hover:opacity-90"
          style={{ backgroundColor: '#D77A52' }}
        >
          Create your free account
        </Link>
        <p className="mt-5">
          <span style={{ color: '#C4A98C' }}>Already have an account?{' '}</span>
          <Link to="/signin" className="font-bold underline" style={{ color: '#9FD8DA' }} data-testid="landing-final-cta-signin">
            Sign in
          </Link>
        </p>
      </div>
    </section>
  );
}
